import { TextualSeparatorDataType } from "../../interfaces/textualSeparator/TextualSeparator.type";
import useAppStore from "../../store/AppStore";
import styles from "./TextualSeparator.module.css";
export default function TextualSeparator({
  item,
}: {
  item: TextualSeparatorDataType;
}) {
  const { isDeviceMobile } = useAppStore();
  const style = {
    "--lineColor": item?.lineColor,
  } as React.CSSProperties;

  let textStyle = {
    color: item?.textColor,
  } as React.CSSProperties;
  if (item?.backgroundColor) {
    textStyle = {
      ...textStyle,
      background: item?.backgroundColor,
    };
  }

  return (
    <div
      className={`vas-fs-6  ${styles.lined_text} ${styles.line_before_text} ${
        styles.line_after_text
      } vas-fw-normal vas-w-100 ${isDeviceMobile ? "vas-my-5" : "vas-my-3"}`}
      style={style}
    >
      <span className={`vas-rounded-circle vas-p-round-or`} style={textStyle}>
        {item?.text ?? ""}
      </span>
    </div>
  );
}
